const statistics = {
  publications: {
    total: 31,
    sci: 11,
    national: 2,
    conferences: 18
  },
  projects: {
    total: 7,
    ongoing: 1,
    completed: 6
  },
  students: {
    masters: 5,
    phd: 0
  },
  hIndex: "8+",
  citations: "150+",
  yearsOfExperience: 25
};

export default statistics;

